<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect ref="frame" id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g ref="bg">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/silhouette/Silouette1-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/silhouette/Silouette1-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/silhouette/Silouette1-1280w.jpg`" media="(max-width: 1280px)">
              <source :srcset="`${publicPath}scenes/silhouette/Silouette1-1920w.jpg`" media="(max-width: 1920px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/silhouette/Silouette1.jpg`" />
            </picture>
          </foreignObject>
        </g>
        <g ref="silly" transform="translate(92 107)">
          <ImageLazy width="3833" height="2333" :srcs="[
            `${publicPath}scenes/silhouette/Silouette2-q80-w800.png`,
            `${publicPath}scenes/silhouette/Silouette2.png`
          ]"/>
        </g>
      </g>
    </svg>
    <SceneDialogue
      :ref="`dialogue-1`"
      :width=".28"
      :tx="0.04" :ty="0.15"
      :fontSize="18"
      :bg="`transparent`"
      :className="`minion`">
      I remember a month after Max passed, my niece rounded up all my nieces
      and nephews and went down to Tsegi in the trucks. They drove all the way
      up the Canyon to the ruins in Keet Seel and back.
    </SceneDialogue>
    <SceneDialogue
      :ref="`dialogue-2`"
      :width=".31"
      :tx="0.45" :ty="0.135"
      :fontSize="18"
      :bg="`transparent`"
      :className="`minion`">
      They laughed, cried, told jokes. They shared stories about their
      grandfather Max. They were happy to be together. They knew that Max
      would have wanted them to remember him in their own way.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/silhouette/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const {main, silly, bg} = this.$refs
    const d1 = this.$refs["dialogue-1"].$el
    const d2 = this.$refs["dialogue-2"].$el
    TweenLite.set(bg, {opacity: 0, scale: 1.2, transformOrigin: "center center"})
    TweenLite.set(silly, {opacity: 0})
    TweenLite.set(d1, {opacity: 0})
    TweenLite.set(d2, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(bg, 3, {opacity: 1, scale: 1}))
    this.tl.add(TweenLite.to(silly, 2, {opacity: 1}))
    this.tl.add(TweenLite.to(d1, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d2, 1, {opacity: 1}), "-=0.5")
  },
  methods: {
    enter() {this.tl.play()}
  },
  props: ["slide"]
}
</script>
